import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../components/Seo";
import { CallCta } from "../components/CallCta";
import { Testimonials } from "../components/Testimonials";
import { REGIONS, getCity } from "../data/site";

export default function AreasIndex() {
  return (
    <div data-testid="areas-index-page">
      <Seo
        title="Manitoba Security Service Areas | All Cities Covered"
        description="1st Nations Security serves every region of Manitoba — Winnipeg, Brandon, Steinbach, Thompson, Portage la Prairie, and 20+ more communities. 24/7 guards."
        path="/service-areas/"
        jsonLd={[breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Service Areas", path: "/service-areas" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#FF9100]" data-testid="breadcrumb-home">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Service Areas</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Security Guard Service Areas Across <span className="text-[#FF9100]">Manitoba</span>
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-6">
            1st Nations Security provides security guard services in every region of Manitoba — from Winnipeg's commercial core to northern communities like Thompson, The Pas, Flin Flon, and Churchill. Wherever your people, property, or project is located, our licensed guards and mobile patrols can reach it.
          </p>
          <p className="text-gray-400 leading-relaxed max-w-3xl mb-12">
            Select your city below for local service details, or call our 24/7 dispatch line at +1 807-770-0243 to arrange coverage anywhere in Manitoba.
          </p>
          {REGIONS.map((r) => (
            <div key={r.key} className="mb-12" data-testid={`region-${r.key}`}>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-[#FF9100]" /> {r.title}
              </h2>
              <p className="text-gray-400 leading-relaxed max-w-3xl mb-6">{r.body}</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {r.cities.map(getCity).filter(Boolean).map((c) => (
                  <Link
                    key={c.slug}
                    to={`/security-guards/${c.slug}`}
                    data-testid={`area-card-${c.slug}`}
                    className="group bg-[#14161C] hover:bg-[#1C1F28] border border-white/8 hover:border-[#FF9100]/40 rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-heading font-semibold text-white group-hover:text-[#FF9100] transition-colors">{c.name}, MB</h3>
                      <ArrowRight className="w-4 h-4 text-[#FF9100] opacity-0 group-hover:opacity-100 transition-opacity" />
                    </div>
                    <p className="text-xs text-gray-500 mb-2">Population {c.pop}</p>
                    <p className="text-sm text-gray-400 leading-relaxed">{c.desc}</p>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <Testimonials />
      <CallCta heading="Your City Not Listed?" sub="We serve every Manitoba community — call our 24/7 dispatch to arrange coverage at your location." testid="areas-cta" />
    </div>
  );
}
